"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = exports.StyledBreadcrumbs = void 0;
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
//@ts-ignore
const services_1 = require("@qsite/services");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const __1 = require("..");
exports.StyledBreadcrumbs = styled_components_1.default.nav `
	display: flex;
	margin-left: 10px;
	flex-direction: row;
	align-self: flex-start;

	li {
		list-style-type: none;
		display: inline-block;
		min-height: 44px;
	}

	svg {
		margin-right: 10px;
		margin-left: 10px;
		color: ${({ theme }) => theme.gray2};
		
	}

	a, span {
		padding: 15px 5px 15px 5px;
		font-size: 16px;
		line-height: 44px;
	}

	a {
		color: ${({ theme }) => theme.denimBlue};
	}

	@media(max-width: 41em) {
		margin: 0;
		ul {
			padding: 0;
		}
		padding-left: 10px;
		padding-right: 10px;
		width: calc(100% - 20px);

		a, span {
			font-size: 14px;
		}
	}
`;
const Breadcrumbs = (props) => {
    const location = react_router_dom_1.useLocation();
    const [state, dispatch] = services_1.useStore();
    const resetHook = services_1.useReset();
    const { translatedKeys, crumbs } = props;
    const handleClick = (e, i) => {
        // Prevent unwanted click behaviors
        e.preventDefault();
        e.stopPropagation();
        switch (props.type) {
            case 'hierarchic':
                const { hierarchicOptions, crumbs: crumbsHierarchic } = props;
                const crumbHierarchic = crumbsHierarchic[i];
                const { setBreadcrumbs, setCatalogStep, setCurrentOptions } = hierarchicOptions;
                let newOptions = [];
                if (crumbHierarchic.categories.length > 0) {
                    newOptions = crumbHierarchic.categories;
                }
                else if (crumbHierarchic.catalog_items != null && crumbHierarchic.catalog_items.length > 0) {
                    newOptions = crumbHierarchic.catalog_items;
                }
                setBreadcrumbs(prevState => prevState.slice(0, i + 1));
                setCatalogStep(i);
                setCurrentOptions(newOptions);
                break;
            case 'navigation':
                const { navigationConfig, crumbs: crumbsNavigation } = props;
                const crumbNavigation = crumbsNavigation[i];
                const { confirmModalResolver, routesResetFunction } = navigationConfig;
                const currentPage = location.pathname;
                if (crumbNavigation.action) { // todo: temporary solution for BBTI
                    crumbNavigation.action();
                }
                else {
                    // Check if route needs confirmation
                    const modalType = confirmModalResolver(crumbNavigation.pathToNavigate, currentPage);
                    if (modalType !== 'NO_SHOW') {
                        dispatch(services_1.appSettingsActions.setApplicationModal({ modalType: modalType, breadcrumbTo: crumbNavigation.pathToNavigate }));
                    }
                    else {
                        // reset store data if neccessary
                        const resetFunctionName = routesResetFunction[crumbNavigation.pathToNavigate];
                        if (resetFunctionName != null) {
                            const resetFunction = resetHook[resetFunctionName];
                            resetFunction();
                        }
                        dispatch(services_1.appSettingsActions.setProgress({ path: crumbNavigation.pathToNavigate, method: __1.NAVIGATION_ACTION.PUSH }));
                    }
                }
                break;
            default:
                break;
        }
    };
    const isBreadcrumbEnabled = (i) => {
        let breadcrumbEnabled = true;
        const resetAssessmentCrumb = props.type === 'navigation' && props.assessmentStep > 0;
        if (i === crumbs.length - 1 && !resetAssessmentCrumb) {
            breadcrumbEnabled = false;
        }
        return breadcrumbEnabled;
    };
    return (react_1.default.createElement(exports.StyledBreadcrumbs, { "aria-label": translatedKeys.ariaLabel },
        react_1.default.createElement("ul", null, crumbs.map((crumb, i) => {
            const breadcrumbEnabled = isBreadcrumbEnabled(i);
            return (react_1.default.createElement("li", { key: i },
                i !== 0 && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faChevronRight }),
                breadcrumbEnabled ?
                    react_1.default.createElement("a", { href: "#", "data-testid": 'breadcrumb-link', onClick: (e) => handleClick(e, i) }, crumb.name_friendly || crumb.name)
                    :
                        react_1.default.createElement("span", { "data-testid": 'breadcrumb-current', "aria-current": 'location' }, crumb.name_friendly || crumb.name)));
        }))));
};
exports.Breadcrumbs = Breadcrumbs;
